var React = require('react');

function ProductsIcon37Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Obszar_roboczy_53","data-name":"Obszar roboczy 53","d":"M31.09,6.16v20.1H22.6V20.75l6.04-3.49-1.05-1.82h0l-2.68-4.63h.01L23.87,8.98,5.83,19.38,6.88,21.2l2.57-1.49,2.68,4.63h0l1.05,1.82L20,22.22v6.61H31.08v4.99h2.48V6.16H31.08ZM11.29,18.67,23.1,11.85l2.68,4.63L13.97,23.3l-2.68-4.63Z","transform":"translate(-5.83 -6.16)"}));
}

ProductsIcon37Inline.defaultProps = {"width":"27.73","height":"27.66","viewBox":"0 0 27.73 27.66"};

module.exports = ProductsIcon37Inline;

ProductsIcon37Inline.default = ProductsIcon37Inline;
